<template>
  <div id="intererfassung" class="container">
    <h2 v-if="ueberschrift" class="p">{{ ueberschrift }}</h2>
    <div v-if="adressdaten == null || adressdaten.technologie == 'FTTH'" v-html="text"></div>
    <div v-else-if="adressdaten.technologie == 'HFC'" v-html="hfcInformationen.redaktion"></div>
    <div v-if="zeigeDanke">
      <h4>{{ lang.danke_ueberschrift }}</h4>
      <div class="shadowbox">
        <div class="row">
          <div class="col-sm-12">
            <label>{{ lang.danke_text }}</label>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p v-if="adressdaten && adressdaten.adressmeldung" v-html="adressdaten.adressmeldung"></p>
      <p v-else-if="adressMeldung">
        <strong>{{ adressMeldung }}</strong>
      </p>
      <h3>Adresse</h3>
      <div class="shadowbox my-4">
        <template v-if="adressdaten">
          <p class="my-2">
            <span>
              <span>
                PLZ
              </span>
            </span>
            <span>
              <span title="Postleitzahl">{{ adressdaten.plz }}</span>
            </span>
          </p>
          <p class="my-2">
            <span>
              <span>
                Wohnort
              </span>
            </span>
            <span>
              <span title="Ort">{{ adressdaten.ort }}</span>
            </span>
          </p>
          <p class="my-2">
            <span>
              <span>
                Straße
              </span>
            </span>
            <span>
              <span title="Strasse">{{ adressdaten.strasse || adressdaten.str }}</span>
            </span>
          </p>
          <p class="my-2">
            <span>
              <span>
                Hausnr.
              </span>
            </span>
            <span>
              <span title="Hausnummer">{{ adressdaten.hausnummer || adressdaten.hnr }}</span>
            </span>
          </p>
        </template>
        <template v-else>
          <p class="my-2">
            <span>
              <span>
                PLZ
              </span>
            </span>
            <span>
              <span title="Postleitzahl">{{ adresse.plz }}</span>
            </span>
          </p>
          <p class="my-2">
            <span>
              <span>
                Wohnort
              </span>
            </span>
            <span>
              <span title="Ort">{{ adresse.ort }}</span>
            </span>
          </p>
          <p class="my-2">
            <span>
              <span>
                Straße
              </span>
            </span>
            <span>
              <span title="Strasse">{{ adresse.strasse || adresse.str }}</span>
            </span>
          </p>
          <p class="my-2">
            <span>
              <span>
                Hausnr.
              </span>
            </span>
            <span>
              <span title="Hausnummer">{{ adresse.hausnummer || adresse.hnr }}</span>
            </span>
          </p>
        </template>
      </div>
      <template v-if="adressdaten && adressdaten.technologie == 'HFC' && hfcProduktAuswahl">
        <h4>Ich bin an folgendem Produkt interessiert</h4>
        <div class="shadowbox form">
          <div class="row">
            <div class="col-xs-12 col-sm-6">
              <div class="form-group">
                <select
                  v-model="produktinteresse"
                  class="grouped-input"
                  name="interresse_Produkt"
                  style="height: 62px;background-color:#ededed;border-radius: 0!important;border: none!important;"
                >
                  <option v-for="p in hfcProduktAuswahl" :key="'k' + p.id" :value="p.id">{{ p.title }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </template>
      <h4>Weitere Daten</h4>
      <formular @absenden="interessent => absenden(interessent, produktinteresse)" :lang="lang"></formular>
    </div>
  </div>
</template>

<script>
import { SET_ADRESSE, SET_IDS } from '@/store/mutations.type'
import { LADE_ADRESSDATEN } from '@/store/actions.type'

import api from '@/api/interessent'
import language from '@/api/language'
import store from '@/store'
import Formular from '@/components/Formular'
// import { SET_LANGUAGE } from '../store/mutations.type'

export default {
  name: 'App',
  store,
  components: {
    Formular,
  },
  data() {
    return {
      qParams: this.$route.query,
      lang: {},
      zeigeDanke: false,
      produktinteresse: null,
    }
  },
  async mounted() {
    //https://kms.eins.de/intererfassung/?plz=08626&ort=Adorf/Vogtl. OT Arnsgrün&strasse=Adorfer Str.&hnr=2&adressenID=183550BED07&kundentypID=12186C143B2
    //http://localhost:8080/?plz=08626&ort=Adorf/Vogtl. OT Arnsgrün&strasse=Adorfer Str.&hnr=2&adressenID=183550BED07&kundentypID=12186C143B2

    console.log(JSON.stringify(this.$route.query))
    let adresse = {
      plz: this.qParams.plz,
      ort: this.qParams.ort,
      strasse: this.qParams.strasse,
      hnr: this.qParams.hnr,
    }
    this.$store.commit(SET_ADRESSE, adresse)

    let ids = {
      adressenID: this.qParams.adressenID,
      kundentypID: this.qParams.kundentypID,
      adressMeldungenID: this.qParams.adressMeldungenID,
    }
    this.$store.commit(SET_IDS, ids)

    let response = await language.getLanguage()
    //this.$store.commit(SET_LANGUAGE, response.data)
    this.lang = response.data
  },

  async created() {
    // hole Adressmeldung im Klartext
    //await this.$store.dispatch(LADE_ADRESSMELDUNG, this.qParams.adressMeldungenID)
    await this.$store.dispatch(LADE_ADRESSDATEN, this.qParams.adressenID)
  },

  computed: {
    // lang() {
    //   return this.$store.state.language
    // },
    text() {
      return this.lang?.text
    },
    ueberschrift() {
      return this.lang?.ueberschrift
    },
    adressdaten() {
      return this.$store.state.adressdaten
    },
    adresse() {
      return this.$store.state.adresse
    },
    ids() {
      return this.$store.state.ids
    },
    verbindlich() {
      return this.qParams.verb || false
    },
    adressMeldung() {
      return this.$store.state.adressmeldung
    },
    hfcInformationen() {
      return (
        window.hfcInformationen || {
          redaktion: '',
          produkt_Auswahl: [],
        }
      )
    },
    hfcProduktAuswahl() {
      if (
        this.hfcInformationen &&
        this.hfcInformationen.produkt_Auswahl &&
        Array.isArray(this.hfcInformationen.produkt_Auswahl) &&
        this.hfcInformationen.produkt_Auswahl.length > 0
      )
        return this.hfcInformationen.produkt_Auswahl
      else return null
    },
  },
  methods: {
    async absenden(interessent, produktinteresse = null) {
      try {
        // this.isLoading = true;
        let json = Object.assign({}, { adresse: this.adresse }, { interessent: interessent }, { produktinteresse: produktinteresse }, { ids: this.ids }, { verbindlich: this.verbindlich })
        let response = await api.post(json)
        if (response.data.state === 201) {
          //alert(JSON.stringify(response.data.state));
          this.zeigeDanke = true
        } else {
          //
        }
      } finally {
        // this.isLoading = false;
      }
    },
  },
}
</script>

<style lang="scss">
@import './scss/app.scss';
</style>
